<template>
  <stepper-container>
    <stepper-step
      v-for="(step, index) in steps"
      :key="index"
      :currentStep="currentStep"
      :stepNo="index + 1"
      :title="step.title"
      :subtitle="step.subtitle"
    >
      <component
        :is="step.component"
        v-if="currentStep > index"
        :stepNumber="index + 1"
        @completed="updateProgress"
      ></component>
    </stepper-step>
  </stepper-container>
</template>
<script>
import { mapGetters } from 'vuex';
import SubmitAddressProof from '../components/SubmitAddressProof.vue';
import SubmitPersonalDetails from '../components/SubmitPersonalDetails.vue';
import StepperContainer from '../components/StepperContainer.vue';
import StepperStep from '../components/StepperStep.vue';

export default {
  name: 'PreApprovalStep2',
  components: {
    SubmitAddressProof,
    SubmitPersonalDetails,
    StepperContainer,
    StepperStep,
  },
  computed: {
    ...mapGetters(['skipBusinessProfileInReferral'])
  },
  data() {
    return {
      currentStep: undefined,
      steps: [
        {
          title: 'Upload address Proof',
          subtitle: 'एड्रेस प्रूफ अपलोड करें',
          component: 'submit-address-proof'
        },
        { title: 'Personal Information', component: 'submit-personal-details' },
      ]
    };
  },
  methods: {
    updateProgress(stepNumber) {
      this.currentStep = stepNumber;
      if ((this.currentStep) > this.steps.length) {
        this.$router.push({ name: this.$route.meta.isEdit || this.skipBusinessProfileInReferral ? 'Pre Approval Review' : 'Pre Approval Step 3' });
      }
    }
  },
  mounted() {
    this.currentStep = this.$route?.meta?.isEdit ? 2 : 1;
  },
};

</script>
